const ORG_TYPE_LIST = [
  { type: 'office', name: 'Office' },
  // { type: 'residential', name: 'Residential' },
  // { type: 'hospitality', name: 'Hospitality' },
  // { type: 'integrated', name: 'Integrated Organization' },
];

export default ORG_TYPE_LIST;
